import { render, staticRenderFns } from "./CollectionProduct.vue?vue&type=template&id=343e6fc6&"
import script from "./CollectionProduct.vue?vue&type=script&lang=js&"
export * from "./CollectionProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports